
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iDxDj", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3lWl0 = parcelRequire("3lWl0");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");



var $1P7Cq = parcelRequire("1P7Cq");


var $7Sm4c = parcelRequire("7Sm4c");


var $laFNM = parcelRequire("laFNM");


var $qP1yw = parcelRequire("qP1yw");


var $8EyOs = parcelRequire("8EyOs");


var $bJX6u = parcelRequire("bJX6u");


var $3qCob = parcelRequire("3qCob");


var $9kBwp = parcelRequire("9kBwp");

function $f084987bc41bc5d5$var$computeContentStateValuesFromData(data, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode) {
    const newContentStateValues = Object.assign({}, (0, $bJX6u.defaultValues));
    /**  Computes content state values from query response data. Used for both SSR bootstrap (useEffect never runs on
    server, so we compute state from preloaded data for initial render) and client useEffect (setInitialValues).
    Setting shouldRunContentStateEffect = false prevents the effect from running again on parent re-renders
    (EditorContentState lives in breadcrumbs/title area), which would otherwise reset the values.
  */ newContentStateValues.shouldRunContentStateEffect = false;
    newContentStateValues.contentState = data?.singleContent?.contentState || null;
    newContentStateValues.contentStateLastUpdated = data?.singleContent?.contentStateLastUpdated?.value || null;
    newContentStateValues.defaultStatesArray = defaultStatesArray;
    newContentStateValues.customStatesArray = customStatesArray;
    // Only check availableContentStates when the user has edit permission.
    // In view-only mode, availableContentStates is either skipped via @skip directive
    // or absent entirely (renderer fallback query), so we must not treat its absence
    // as "content states disabled".
    if (!isViewOnlyMode) {
        const editorData = data;
        const isSuggestedContentStatesDisabled = !editorData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !editorData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) newContentStateValues.isCustomEnabled = false;
    }
    newContentStateValues.lastFetchedIsDraft = isDraft;
    newContentStateValues.lastFetchedContentId = contentId;
    return newContentStateValues;
}
const $f084987bc41bc5d5$var$EditorContentStateDataGetter = (t0)=>{
    const $ = (0, $bDgLe.c)(115);
    const { contentId: contentId, contentType: contentType, contentStateState: contentStateState, isPublishingContent: isPublishingContent, userOffline: userOffline, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick, isViewMode: isViewMode, canEdit: canEdit } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const isDraft = !isViewMode && !isCurrentPageLive;
    const { approvalRequest: approvalRequest, isContentApprovalsEnabled: isContentApprovalsEnabled, disallowFirstPublish: disallowFirstPublish } = (0, $laFNM.useApprovals)();
    const hasApprovalStatus = !!approvalRequest?.application?.workflowStatusId;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const isViewOnlyMode = !!(isViewMode && canEdit === false);
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const editorContentStateFragment = (0, $9kBwp.useEditorContentStateFragment)(t1);
    let t2;
    if ($[2] !== isCurrentPageLive) {
        t2 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isCurrentPageLive;
        $[2] = isCurrentPageLive;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contentId || $[6] !== isDraft || $[7] !== isViewOnlyMode || $[8] !== t2) {
        t4 = {
            contentId: contentId,
            isDraft: isDraft,
            shouldSkipContentStateLastUpdated: t2,
            isApprovalsFgOn: t3,
            format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY",
            shouldSkipAvailableContentStates: isViewOnlyMode,
            shouldSkipEditOnlyFields: isViewOnlyMode
        };
        $[5] = contentId;
        $[6] = isDraft;
        $[7] = isViewOnlyMode;
        $[8] = t2;
        $[9] = t4;
    } else t4 = $[9];
    const t5 = t4;
    let t6;
    if ($[10] !== contentStateState.state.shouldRunContentStateEffect || $[11] !== editorContentStateFragment.isProvided) {
        t6 = editorContentStateFragment.isProvided || ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !contentStateState.state.shouldRunContentStateEffect);
        $[10] = contentStateState.state.shouldRunContentStateEffect;
        $[11] = editorContentStateFragment.isProvided;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
        t7 = {
            fetchPolicy: window.__SSR_RENDERED__ ? "cache-first" : "network-only",
            variables: t5,
            skip: t6
        };
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    const queryResult = (0, $jMyy4.useQueryInterop)((0, $3lWl0.default), {
        ...t7,
        __callerPackage__: "content-state"
    });
    const { data: data, error: error } = editorContentStateFragment.isProvided ? editorContentStateFragment : queryResult;
    const { refetch: refetch } = queryResult;
    let t8;
    if ($[16] !== contentId || $[17] !== isDraft) {
        t8 = {
            contentId: contentId,
            isDraft: isDraft,
            format: "USER_FRIENDLY"
        };
        $[16] = contentId;
        $[17] = isDraft;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = t8;
    const t10 = !isViewOnlyMode;
    let t11;
    if ($[19] !== t10 || $[20] !== t9) {
        t11 = {
            fetchPolicy: "cache-first",
            variables: t9,
            skip: t10
        };
        $[19] = t10;
        $[20] = t9;
        $[21] = t11;
    } else t11 = $[21];
    const { data: rendererData } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), {
        ...t11,
        __callerPackage__: "content-state"
    });
    const ssrContentStateData = renderServerPlaceholder && isViewOnlyMode && !data && !rendererData ? window.__SSR_CONTENT_STATE__ : null;
    const effectiveData = data ?? (isViewOnlyMode ? rendererData ?? ssrContentStateData : null);
    data?.availableContentStates?.spaceContentStates;
    let t12;
    if ($[22] !== data?.availableContentStates?.spaceContentStates) {
        t12 = data?.availableContentStates?.spaceContentStates?.filter($f084987bc41bc5d5$var$_temp) || [];
        $[22] = data?.availableContentStates?.spaceContentStates;
        $[23] = t12;
    } else t12 = $[23];
    const defaultStatesArray = t12;
    let t13;
    if ($[24] !== data?.availableContentStates?.customContentStates) {
        t13 = ()=>data?.availableContentStates?.customContentStates?.filter($f084987bc41bc5d5$var$_temp2) || [];
        $[24] = data?.availableContentStates?.customContentStates;
        $[25] = t13;
    } else t13 = $[25];
    data?.availableContentStates?.customContentStates;
    let t14;
    if ($[26] !== t13) {
        t14 = t13();
        $[26] = t13;
        $[27] = t14;
    } else t14 = $[27];
    const customStatesArray = t14;
    let ssrContentState = null;
    if (renderServerPlaceholder && effectiveData && effectiveData.singleContent?.id === contentId && contentStateState.state.lastFetchedIsDraft === null && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
        let t15;
        if ($[28] !== contentId || $[29] !== customStatesArray || $[30] !== defaultStatesArray || $[31] !== effectiveData || $[32] !== isDraft || $[33] !== isViewOnlyMode) {
            t15 = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
            $[28] = contentId;
            $[29] = customStatesArray;
            $[30] = defaultStatesArray;
            $[31] = effectiveData;
            $[32] = isDraft;
            $[33] = isViewOnlyMode;
            $[34] = t15;
        } else t15 = $[34];
        ssrContentState = t15;
    }
    if (renderServerPlaceholder && !ssrContentState && !effectiveData && (hasApprovalStatus || isViewOnlyMode) && contentStateState.state.lastFetchedIsDraft === null && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) {
        let t15;
        if ($[35] !== contentId || $[36] !== isDraft) {
            t15 = {
                ...(0, $bJX6u.defaultValues),
                isContentStateEnabled: false,
                shouldRunContentStateEffect: false,
                lastFetchedIsDraft: isDraft,
                lastFetchedContentId: contentId
            };
            $[35] = contentId;
            $[36] = isDraft;
            $[37] = t15;
        } else t15 = $[37];
        ssrContentState = t15;
    }
    const effectiveState = ssrContentState ?? contentStateState.state;
    let t15;
    if ($[38] !== contentStateState.state.lastFetchedIsDraft || $[39] !== isDraft) {
        t15 = contentStateState.state.lastFetchedIsDraft !== null && contentStateState.state.lastFetchedIsDraft !== isDraft && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[38] = contentStateState.state.lastFetchedIsDraft;
        $[39] = isDraft;
        $[40] = t15;
    } else t15 = $[40];
    const isTransitioning = t15;
    let t16;
    let t17;
    if ($[41] !== contentStateState || $[42] !== isTransitioning) {
        t16 = ()=>{
            if (isTransitioning) contentStateState.resetToDefaults();
        };
        t17 = [
            isTransitioning,
            contentStateState
        ];
        $[41] = contentStateState;
        $[42] = isTransitioning;
        $[43] = t16;
        $[44] = t17;
    } else {
        t16 = $[43];
        t17 = $[44];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[45] !== contentId || $[46] !== contentStateState || $[47] !== effectiveData || $[48] !== error || $[49] !== isDraft || $[50] !== isTransitioning || $[51] !== isViewOnlyMode) {
        t18 = ()=>{
            if (!isTransitioning && error) {
                if (isViewOnlyMode && effectiveData) (0, $7Sm4c.markErrorAsHandled)(error);
                else if (!effectiveData && contentStateState.state.shouldRunContentStateEffect && contentStateState.state.lastFetchedIsDraft === null) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    contentStateState.setInitialValues({
                        ...(0, $bJX6u.defaultValues),
                        isContentStateEnabled: false,
                        shouldRunContentStateEffect: false,
                        lastFetchedIsDraft: isDraft,
                        lastFetchedContentId: contentId
                    });
                }
            }
        };
        t19 = [
            error,
            effectiveData,
            contentStateState,
            isDraft,
            contentId,
            isTransitioning,
            isViewOnlyMode
        ];
        $[45] = contentId;
        $[46] = contentStateState;
        $[47] = effectiveData;
        $[48] = error;
        $[49] = isDraft;
        $[50] = isTransitioning;
        $[51] = isViewOnlyMode;
        $[52] = t18;
        $[53] = t19;
    } else {
        t18 = $[52];
        t19 = $[53];
    }
    (0, $cozmU.useEffect)(t18, t19);
    let t20;
    let t21;
    if ($[54] !== contentId || $[55] !== contentStateState || $[56] !== customStatesArray || $[57] !== defaultStatesArray || $[58] !== effectiveData || $[59] !== isDraft || $[60] !== isTransitioning || $[61] !== isViewOnlyMode) {
        t20 = ()=>{
            if (isTransitioning) return;
            if (effectiveData && effectiveData.singleContent?.id === contentId && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
                if (contentStateState.state.isUpdating) {
                    contentStateState.setIsUpdating(false);
                    return;
                }
                const computed = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
                if (contentStateState.isOptimisticOperationPending) {
                    computed.contentState = contentStateState.state.contentState;
                    computed.contentStateLastUpdated = contentStateState.state.contentStateLastUpdated;
                    computed.customStatesArray = contentStateState.state.customStatesArray;
                } else if ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) computed.customStatesArray = (0, $3qCob.reAddAppliedCustomStatusIfMissing)(computed.contentState, computed.customStatesArray, computed.defaultStatesArray, contentStateState.state.customStatesArray);
                contentStateState.setInitialValues(computed);
            }
        };
        t21 = [
            effectiveData,
            contentStateState,
            defaultStatesArray,
            customStatesArray,
            isDraft,
            isTransitioning,
            contentId,
            isViewOnlyMode
        ];
        $[54] = contentId;
        $[55] = contentStateState;
        $[56] = customStatesArray;
        $[57] = defaultStatesArray;
        $[58] = effectiveData;
        $[59] = isDraft;
        $[60] = isTransitioning;
        $[61] = isViewOnlyMode;
        $[62] = t20;
        $[63] = t21;
    } else {
        t20 = $[62];
        t21 = $[63];
    }
    (0, $cozmU.useEffect)(t20, t21);
    let t22;
    let t23;
    if ($[64] !== contentId || $[65] !== contentStateState) {
        t22 = ()=>{
            const guardedContentId = contentStateState.keepEmptyTriggerForContentId;
            if (guardedContentId !== null && guardedContentId !== contentId) contentStateState.setKeepEmptyTriggerForContentId(null);
        };
        t23 = [
            contentId,
            contentStateState
        ];
        $[64] = contentId;
        $[65] = contentStateState;
        $[66] = t22;
        $[67] = t23;
    } else {
        t22 = $[66];
        t23 = $[67];
    }
    (0, $cozmU.useEffect)(t22, t23);
    let t24;
    if ($[68] !== contentType || $[69] !== disallowFirstPublish || $[70] !== effectiveState || $[71] !== hasApprovalStatus || $[72] !== isContentApprovalsEnabled || $[73] !== isViewMode || $[74] !== renderServerPlaceholder) {
        t24 = !renderServerPlaceholder && Boolean(isViewMode) && contentType === "page" && !(effectiveState.contentState || hasApprovalStatus) && isContentApprovalsEnabled && disallowFirstPublish && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && (0, $6mKj3.expValEquals)("confluence_approvals_entry_point_updates_exp", "isEnabled", true);
        $[68] = contentType;
        $[69] = disallowFirstPublish;
        $[70] = effectiveState;
        $[71] = hasApprovalStatus;
        $[72] = isContentApprovalsEnabled;
        $[73] = isViewMode;
        $[74] = renderServerPlaceholder;
        $[75] = t24;
    } else t24 = $[75];
    const showApprovalRequiredEmptyStatus = t24;
    let t25;
    if ($[76] !== contentId || $[77] !== contentStateState.keepEmptyTriggerForContentId || $[78] !== effectiveState || $[79] !== isTransitioning || $[80] !== isViewMode) {
        t25 = isViewMode && contentStateState.keepEmptyTriggerForContentId === contentId && !isTransitioning && !(effectiveState.lastFetchedContentId !== null && effectiveState.lastFetchedContentId !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[76] = contentId;
        $[77] = contentStateState.keepEmptyTriggerForContentId;
        $[78] = effectiveState;
        $[79] = isTransitioning;
        $[80] = isViewMode;
        $[81] = t25;
    } else t25 = $[81];
    const keepEmptyTriggerVisible = t25;
    let t26;
    if ($[82] !== canEdit || $[83] !== contentId || $[84] !== contentType || $[85] !== effectiveState || $[86] !== floatingToolbarButtonStyle || $[87] !== hasApprovalStatus || $[88] !== isTransitioning || $[89] !== isViewMode || $[90] !== keepEmptyTriggerVisible || $[91] !== renderPlusButtonEmptyState || $[92] !== showApprovalRequiredEmptyStatus) {
        t26 = keepEmptyTriggerVisible || !isTransitioning && !(effectiveState.lastFetchedContentId !== null && effectiveState.lastFetchedContentId !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) && !(effectiveState.shouldRunContentStateEffect && effectiveState.lastFetchedIsDraft === null) && !(!effectiveState.isContentStateEnabled && !effectiveState.contentState && !hasApprovalStatus && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && !canEdit && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && contentType === "blogpost" && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(!(effectiveState.contentState || hasApprovalStatus) && !floatingToolbarButtonStyle && !renderPlusButtonEmptyState && !showApprovalRequiredEmptyStatus && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
        $[82] = canEdit;
        $[83] = contentId;
        $[84] = contentType;
        $[85] = effectiveState;
        $[86] = floatingToolbarButtonStyle;
        $[87] = hasApprovalStatus;
        $[88] = isTransitioning;
        $[89] = isViewMode;
        $[90] = keepEmptyTriggerVisible;
        $[91] = renderPlusButtonEmptyState;
        $[92] = showApprovalRequiredEmptyStatus;
        $[93] = t26;
    } else t26 = $[93];
    const shouldRenderUI = t26;
    if (shouldRenderUI && isPublishingContent) createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "publishedWithContentState",
            actionSubject: "page",
            objectId: contentId,
            source: "editorContentState",
            attributes: {
                contentStatus: isViewMode ? "CURRENT" : "DRAFT"
            }
        }
    }).fire();
    let t27;
    if ($[94] !== isViewMode || $[95] !== refetch) {
        t27 = isViewMode && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: [
                (0, $c0urc.ReloadType).content
            ],
            reload: refetch
        });
        $[94] = isViewMode;
        $[95] = refetch;
        $[96] = t27;
    } else t27 = $[96];
    let t28;
    if ($[97] !== canEdit || $[98] !== contentId || $[99] !== contentStateState || $[100] !== contentType || $[101] !== effectiveState || $[102] !== floatingToolbarButtonStyle || $[103] !== isDetailsPanel || $[104] !== isViewMode || $[105] !== onClick || $[106] !== onContentStateMenuToggle || $[107] !== renderPlusButtonEmptyState || $[108] !== shouldRenderUI || $[109] !== showApprovalRequiredEmptyStatus || $[110] !== userOffline) {
        t28 = shouldRenderUI && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qP1yw.LazyEditorContentStateComponent), {
            contentId: contentId,
            contentType: contentType,
            contentStateState: {
                ...contentStateState,
                state: effectiveState
            },
            userOffline: userOffline,
            onContentStateMenuToggle: onContentStateMenuToggle,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            onClick: onClick,
            isViewMode: isViewMode,
            canEdit: canEdit,
            showApprovalRequiredEmptyStatus: showApprovalRequiredEmptyStatus
        });
        $[97] = canEdit;
        $[98] = contentId;
        $[99] = contentStateState;
        $[100] = contentType;
        $[101] = effectiveState;
        $[102] = floatingToolbarButtonStyle;
        $[103] = isDetailsPanel;
        $[104] = isViewMode;
        $[105] = onClick;
        $[106] = onContentStateMenuToggle;
        $[107] = renderPlusButtonEmptyState;
        $[108] = shouldRenderUI;
        $[109] = showApprovalRequiredEmptyStatus;
        $[110] = userOffline;
        $[111] = t28;
    } else t28 = $[111];
    let t29;
    if ($[112] !== t27 || $[113] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t27, t28);
        $[112] = t27;
        $[113] = t28;
        $[114] = t29;
    } else t29 = $[114];
    return t29;
};
const $f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($f084987bc41bc5d5$var$EditorContentStateDataGetter);
const $f084987bc41bc5d5$var$contentStateContainers = [
    (0, $bJX6u.ContentStateStateContainer)
];
const $f084987bc41bc5d5$export$2791e79b1a186ba4 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $f084987bc41bc5d5$var$contentStateContainers
        }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary, {
                ...props,
                contentStateState: contentStateState
            }));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $f084987bc41bc5d5$var$_temp(i) {
    return !!i;
}
function $f084987bc41bc5d5$var$_temp2(i_0) {
    return !!i_0;
}
module.exports["EditorContentState"] = $f084987bc41bc5d5$export$2791e79b1a186ba4;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $lJswu = parcelRequire("lJswu");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("6nX68"))).EditorContentStateComponent;
    },
    loading: (0, $lJswu.ContentStateSkeleton)
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("ejQ8j"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("lJswu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("dzxx6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");

const $62a49c8d20755563$var$loadingPlaceholderStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100',
    backgroundColor: 'utility.elevation.surface.current'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1kk5Tkf7mX _0fKRyPnQyn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$contentStateColorPlaceholderStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentState: contentState } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $62a49c8d20755563$var$contentStateColorPlaceholderStyles,
            testId: "subtle-renderer-content-state-color-placeholder"
        });
        $[0] = t1;
    } else t1 = $[0];
    const t2 = contentState?.name;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            xcss: $62a49c8d20755563$var$loadingPlaceholderStyles,
            testId: "subtle-renderer-content-state-placeholder"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t2)));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("6nX68", function(module, exports) {

let $4a62bbac19c19a10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4a62bbac19c19a10$var$load("bncmK"),
    $4a62bbac19c19a10$var$load("6WPx8"),
    $4a62bbac19c19a10$var$load("aP4DK"),
    $4a62bbac19c19a10$var$load("d3PpR"),
    $4a62bbac19c19a10$var$load("3eyRH"),
    $4a62bbac19c19a10$var$load("bAgF6"),
    $4a62bbac19c19a10$var$load("hnpcA"),
    $4a62bbac19c19a10$var$load("el56J"),
    $4a62bbac19c19a10$var$load("5v3VX"),
    $4a62bbac19c19a10$var$load("MeTq1"),
    $4a62bbac19c19a10$var$load("b6eef"),
    $4a62bbac19c19a10$var$load("9J1M7"),
    $4a62bbac19c19a10$var$load("15jTz"),
    $4a62bbac19c19a10$var$load("48F3z"),
    $4a62bbac19c19a10$var$load("6wr18"),
    $4a62bbac19c19a10$var$load("59hV4"),
    $4a62bbac19c19a10$var$load("5MQ0D"),
    $4a62bbac19c19a10$var$load("lOurc"),
    $4a62bbac19c19a10$var$load("ckcH3"),
    $4a62bbac19c19a10$var$load("jL1Ke"),
    $4a62bbac19c19a10$var$load("fuOfV"),
    $4a62bbac19c19a10$var$load("iWnyc"),
    $4a62bbac19c19a10$var$load("ea3NB"),
    $4a62bbac19c19a10$var$load("ffEVr"),
    $4a62bbac19c19a10$var$load("9cpj1"),
    $4a62bbac19c19a10$var$load("20wSi"),
    $4a62bbac19c19a10$var$load("d0ZRF"),
    $4a62bbac19c19a10$var$load("k507P"),
    $4a62bbac19c19a10$var$load("fwbNS"),
    $4a62bbac19c19a10$var$load("h4Nf7"),
    $4a62bbac19c19a10$var$load("9TOep"),
    $4a62bbac19c19a10$var$load("hhss7"),
    $4a62bbac19c19a10$var$load("7EorR"),
    $4a62bbac19c19a10$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("ejQ8j", function(module, exports) {

let $a6cb4794d1294ded$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6cb4794d1294ded$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("3qCob", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES = 3;
function $41e22d3f43a50651$export$86566dc9e85acb0c(primaryColor) {
    const tokenPrimaryColor = (0, $8miSe.hexToToken)(primaryColor ?? (0, $Uu0Pb.PRIMARY_COLORS).BLUE);
    switch(tokenPrimaryColor){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return (0, $Uu0Pb.SECONDARY_COLORS).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return (0, $Uu0Pb.SECONDARY_COLORS).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return (0, $Uu0Pb.SECONDARY_COLORS).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return (0, $Uu0Pb.SECONDARY_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$6844ce2c0353a555(secondaryColor) {
    const tokenSecondaryColor = (0, $8miSe.hexToToken)(secondaryColor ?? (0, $Uu0Pb.SECONDARY_COLORS).BLUE);
    switch(tokenSecondaryColor){
        case (0, $Uu0Pb.SECONDARY_COLORS).BLUE:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
        case (0, $Uu0Pb.SECONDARY_COLORS).GREEN:
            return (0, $Uu0Pb.HOVER_COLORS).GREEN;
        case (0, $Uu0Pb.SECONDARY_COLORS).YELLOW:
            return (0, $Uu0Pb.HOVER_COLORS).YELLOW;
        case (0, $Uu0Pb.SECONDARY_COLORS).RED:
            return (0, $Uu0Pb.HOVER_COLORS).RED;
        case (0, $Uu0Pb.SECONDARY_COLORS).PURPLE:
            return (0, $Uu0Pb.HOVER_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$ccc9fe24e363c71e(oldContentState, newContentState) {
    if (!oldContentState) return false; // can't be duplicate if we don't even have a content state originally
    return oldContentState.name === newContentState.name && oldContentState.color === newContentState.color;
}
function $41e22d3f43a50651$export$a2f9d64eff18382c(customStatesArray, newCustomState) {
    for(let i = 0; i < customStatesArray.length; ++i){
        if ($41e22d3f43a50651$export$ccc9fe24e363c71e(customStatesArray[i], newCustomState)) return {
            index: i,
            id: customStatesArray[i]?.id
        };
    }
    // if we don't find a match just return null
    return null;
}
function $41e22d3f43a50651$export$cd8fa131e8c8f91e(oldCustomStatesArray, newCustomState) {
    /* Need to check if the state user entered matches an existing custom one in the array.
   If it's a duplicate, it means the state the user just typed in is one that already exists. We must find the index
   and id in the old array and handle it like if an existing custom state was selected
    */ const idAndIndex = $41e22d3f43a50651$export$a2f9d64eff18382c(oldCustomStatesArray, newCustomState);
    if (idAndIndex) // user typed in an existing custom state
    return $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, {
        ...newCustomState,
        id: idAndIndex.id
    }, idAndIndex.index);
    else {
        const newArray = [
            newCustomState,
            ...oldCustomStatesArray
        ];
        if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.pop();
        return newArray;
    }
}
function $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, selectedCustomState, index) {
    // removed the selected custom state by index and then add it to the top of the new array
    const newArray = [
        ...oldCustomStatesArray
    ];
    newArray.splice(index, 1);
    newArray.unshift(selectedCustomState);
    return newArray;
}
const $41e22d3f43a50651$export$7366fe55fc696c82 = 'temp-';
function $41e22d3f43a50651$export$b63091a1c8126966(oldCustomStatesArray, newCustomState) {
    // Drop null entries, the optimistic placeholder, and any prior entry that matches the
    // newly-created state by name or id, so the server state is added exactly once. The type
    // guard narrows the result to ContentState[] (no nulls survive the filter).
    const withoutPlaceholders = oldCustomStatesArray.filter((state)=>state != null && !state.id?.startsWith($41e22d3f43a50651$export$7366fe55fc696c82) && state.name !== newCustomState.name && (newCustomState.id == null || state.id !== newCustomState.id));
    const newArray = [
        newCustomState,
        ...withoutPlaceholders
    ];
    if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.length = $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES;
    return newArray;
}
function $41e22d3f43a50651$export$6d0553ade1700746(appliedContentState, refetchedCustomStatesArray, defaultStatesArray, locallyKnownCustomStatesArray) {
    const isAppliedCustom = !!appliedContentState?.id && !defaultStatesArray.some((s)=>s?.id === appliedContentState.id);
    const missingFromRefetch = isAppliedCustom && !refetchedCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    const knownLocally = locallyKnownCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    if (missingFromRefetch && knownLocally && appliedContentState) return [
        appliedContentState,
        ...refetchedCustomStatesArray
    ];
    return refetchedCustomStatesArray;
}
module.exports["determineSecondaryColor"] = $41e22d3f43a50651$export$86566dc9e85acb0c;
module.exports["determineHoverColor"] = $41e22d3f43a50651$export$6844ce2c0353a555;
module.exports["isDuplicate"] = $41e22d3f43a50651$export$ccc9fe24e363c71e;
module.exports["createNewCustomStatesArrayWhenNewCustomAdded"] = $41e22d3f43a50651$export$cd8fa131e8c8f91e;
module.exports["createNewCustomStatesArrayWhenExistingCustomSelected"] = $41e22d3f43a50651$export$1c741d2b42a2932b;
module.exports["OPTIMISTIC_CUSTOM_STATE_ID_PREFIX"] = $41e22d3f43a50651$export$7366fe55fc696c82;
module.exports["reconcileCustomStatesAfterCreate"] = $41e22d3f43a50651$export$b63091a1c8126966;
module.exports["reAddAppliedCustomStatusIfMissing"] = $41e22d3f43a50651$export$6d0553ade1700746;

});

parcelRegister("Uu0Pb", function(module, exports) {
const $1c48b1994652ad1b$export$af156f0af92331bd = {
    BLUE: "var(--ds-background-accent-blue-subtle, #669DF1)",
    GREEN: "var(--ds-background-accent-green-subtle, #4BCE97)",
    YELLOW: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    RED: "var(--ds-background-accent-red-subtle, #F87168)",
    PURPLE: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    VERIFIED: "var(--ds-icon-accent-blue, #357DE8)"
};
const $1c48b1994652ad1b$export$c70dda424cd479ac = {
    BLUE: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    GREEN: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    RED: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    PURPLE: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
};
const $1c48b1994652ad1b$export$8380141af31d7b6a = {
    BLUE: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    GREEN: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    RED: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    PURPLE: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
};
const $1c48b1994652ad1b$export$e755b4518de49373 = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PURPLE: 'purple'
};
module.exports["PRIMARY_COLORS"] = $1c48b1994652ad1b$export$af156f0af92331bd;
module.exports["SECONDARY_COLORS"] = $1c48b1994652ad1b$export$c70dda424cd479ac;
module.exports["HOVER_COLORS"] = $1c48b1994652ad1b$export$8380141af31d7b6a;
module.exports["COLOR_NAMES"] = $1c48b1994652ad1b$export$e755b4518de49373;

});

parcelRegister("8miSe", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");

const $38122f14841a6560$export$b3a997d9e0eb41e = (color)=>{
    switch(color){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return '#2684FF';
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return '#57D9A3';
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return '#FFC400';
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return '#8777D9';
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return '#FF7452';
        case (0, $Uu0Pb.PRIMARY_COLORS).VERIFIED:
            return '#1d7afc';
        default:
            return '#2684FF';
    }
};
const $38122f14841a6560$export$979ed8c2392c1cb4 = (color)=>{
    const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCaseColor){
        case '#2684FF':
            return (0, $Uu0Pb.PRIMARY_COLORS).BLUE;
        case '#57D9A3':
            return (0, $Uu0Pb.PRIMARY_COLORS).GREEN;
        case '#FFC400':
            return (0, $Uu0Pb.PRIMARY_COLORS).YELLOW;
        case '#8777D9':
            return (0, $Uu0Pb.PRIMARY_COLORS).PURPLE;
        case '#FF7452':
            return (0, $Uu0Pb.PRIMARY_COLORS).RED;
        default:
            return color;
    }
};
function $38122f14841a6560$export$4407ed99ceb09a2c(colorCode) {
    const upperCaseColorCode = colorCode?.toUpperCase();
    switch(upperCaseColorCode){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).PURPLE;
        default:
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
    }
}
module.exports["tokenToHex"] = $38122f14841a6560$export$b3a997d9e0eb41e;
module.exports["hexToToken"] = $38122f14841a6560$export$979ed8c2392c1cb4;
module.exports["colorCodeToColorName"] = $38122f14841a6560$export$4407ed99ceb09a2c;

});

parcelRegister("9kBwp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9QVtk = parcelRequire("9QVtk");


var $2Ym7c = parcelRequire("2Ym7c");


var $hX2PJ = parcelRequire("hX2PJ");

// EditorContentStateQuery's singleContent selection. The field arguments match the refetches
// after a status change, which update these records.
const $e499d8acfef5f77c$var$editorContentStateFragmentNode = (0, $2Ym7c.default);
// Its availableContentStates selection, on Query.
const $e499d8acfef5f77c$var$editorAvailableContentStatesFragmentNode = (0, $9QVtk.default);
function $e499d8acfef5f77c$export$5eb268fc49b7a29b(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const content = (0, $hX2PJ.useEditorContentFragment)("editorContentStateFragment", $e499d8acfef5f77c$var$editorContentStateFragmentNode, t1);
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const availableContentStates = (0, $hX2PJ.useEditorContentFragment)("editorAvailableContentStatesFragment", $e499d8acfef5f77c$var$editorAvailableContentStatesFragmentNode, t2);
    let t3;
    if ($[4] !== availableContentStates || $[5] !== content.data) {
        t3 = content.data && {
            singleContent: content.data,
            availableContentStates: availableContentStates.data?.availableContentStates
        };
        $[4] = availableContentStates;
        $[5] = content.data;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = content.error ?? availableContentStates.error;
    let t5;
    if ($[7] !== content.isProvided || $[8] !== content.loading || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            isProvided: content.isProvided,
            loading: content.loading,
            data: t3,
            error: t4
        };
        $[7] = content.isProvided;
        $[8] = content.loading;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
}
module.exports["useEditorContentStateFragment"] = $e499d8acfef5f77c$export$5eb268fc49b7a29b;

});

parcelRegister("9QVtk", function(module, exports) {
/**
 * @generated SignedSource<<ed39a95dcd7f0cbb0c5296a9a64fd811>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83f11b50ffc55218$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "color"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "contentId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useEditorContentStateFragment_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "contentId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "AvailableContentStates",
                "kind": "LinkedField",
                "name": "availableContentStates",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentState",
                        "kind": "LinkedField",
                        "name": "customContentStates",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentState",
                        "kind": "LinkedField",
                        "name": "spaceContentStates",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "restrictionLevel"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$83f11b50ffc55218$var$node.hash = "b929eaf6ffcfb989eca49bfbc256598c";
var $83f11b50ffc55218$export$2e2bcd8739ae039 = $83f11b50ffc55218$var$node;
module.exports["default"] = $83f11b50ffc55218$export$2e2bcd8739ae039;

});

parcelRegister("2Ym7c", function(module, exports) {
/**
 * @generated SignedSource<<2b906695ae8346e4e585ad8878e54305>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afeda9f91d4749df$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeApprovals"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeLastUpdated"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDraft"
            },
            {
                "defaultValue": "USER_FRIENDLY",
                "kind": "LocalArgument",
                "name": "lastUpdatedFormat"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useEditorContentStateFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    v1 /*: any*/ 
                ],
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "restrictionLevel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isCallerPermitted"
                    },
                    {
                        "condition": "includeApprovals",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "lastModifierAaid"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeLastUpdated",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "format",
                                "variableName": "lastUpdatedFormat"
                            },
                            v1 /*: any*/ 
                        ],
                        "concreteType": "ConfluenceDate",
                        "kind": "LinkedField",
                        "name": "contentStateLastUpdated",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$afeda9f91d4749df$var$node.hash = "9357ed51da1e797003a0662f7fcbe2b8";
var $afeda9f91d4749df$export$2e2bcd8739ae039 = $afeda9f91d4749df$var$node;
module.exports["default"] = $afeda9f91d4749df$export$2e2bcd8739ae039;

});

parcelRegister("hX2PJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $26Yfd = parcelRequire("26Yfd");


var $8bGvp = parcelRequire("8bGvp");

function $4a4d540a0776d558$var$identity(value) {
    return value;
}
function $4a4d540a0776d558$export$b9f4f60a9d12fe91(key, fragmentNode, t0) {
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, skip: t1, mapData: mapData } = t0;
    const skip = t1 === undefined ? false : t1;
    const fragment = (0, $8bGvp.useEditorContentFragments)()[key];
    const isProvided = fragment.isProvided && fragment.contentId === contentId;
    const result = (0, $6SsN4.useFragment)(fragmentNode, isProvided && !skip ? fragment.ref : null);
    const loading = isProvided && !skip && fragment.loading;
    const stableMapData = (0, $26Yfd.useStableCallback)(mapData ?? $4a4d540a0776d558$var$identity);
    let t2;
    if ($[0] !== result || $[1] !== stableMapData) {
        t2 = result?.ok ? stableMapData(result.value) : undefined;
        $[0] = result;
        $[1] = stableMapData;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fragmentNode || $[4] !== result) {
        t3 = result?.ok === false ? new Error(`${(0, $eqEJl.getFragment)(fragmentNode).name} field error`, {
            cause: result.errors
        }) : undefined;
        $[3] = fragmentNode;
        $[4] = result;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isProvided || $[7] !== loading || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            isProvided: isProvided,
            loading: loading,
            data: t2,
            error: t3
        };
        $[6] = isProvided;
        $[7] = loading;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["useEditorContentFragment"] = $4a4d540a0776d558$export$b9f4f60a9d12fe91;

});

parcelRegister("8bGvp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $69682d2fbc90456d$var$getNode = (data)=>data.content?.nodes?.[0];
// Where each fragment's ref is in the operation's data; adding a fragment to the query without a
// selector here fails to compile.
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS = {
    contentTypesHeaderFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentTypesHeaderFragment,
    emojiTitleFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiTitleFragment,
    emojiEverSetPropertyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiEverSetPropertyFragment,
    contentAppearanceFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentAppearanceFragment,
    coverPictureFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.coverPictureFragment,
    titleContentPropertiesFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.titleContentPropertiesFragment,
    contentModeFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentModeFragment,
    shareAndRestrictButtonFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.shareAndRestrictButtonFragment,
    editorSpaceDetailFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorSpaceDetailFragment,
    nativeCollabFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.nativeCollabFragment,
    labelsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.labelsFragment,
    smartCreateFeedbackBannerFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.smartCreateFeedbackBannerFragment,
    favouriteContentFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.favouriteContentFragment,
    migratedRecentlyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.migratedRecentlyFragment,
    editorByLineFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorByLineFragment,
    devDocsAncestorsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.devDocsAncestorsFragment,
    editorContentStateFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorContentStateFragment,
    shareAndRestrictButtonPublicLinkFragment: (data)=>data.shareAndRestrictButtonPublicLinkFragment,
    editorByLineContributorsFragment: (data)=>data.editorByLineContributorsFragment,
    editorAvailableContentStatesFragment: (data)=>data.editorAvailableContentStatesFragment,
    editorCollaboratorsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorCollaboratorsFragment,
    editorCollaboratorsListFragment: (data)=>data.editorCollaboratorsListFragment
};
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS = Object.keys($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS);
function $69682d2fbc90456d$var$mapFragments(toFragment) {
    return Object.fromEntries($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS.map((key)=>[
            key,
            toFragment(key)
        ]));
}
function $69682d2fbc90456d$export$56cbeadb27426f30(data, { contentId: contentId, loading: loading }) {
    return $69682d2fbc90456d$var$mapFragments((key)=>({
            isProvided: true,
            ref: $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS[key](data) ?? null,
            contentId: contentId,
            loading: loading
        }));
}
const $69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS = $69682d2fbc90456d$var$mapFragments(()=>({
        isProvided: false
    }));
const $69682d2fbc90456d$export$faab0246835c7509 = (0, $cozmU.createContext)($69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS);
function $69682d2fbc90456d$export$2e53e9edef0785f2() {
    return (0, $cozmU.useContext)($69682d2fbc90456d$export$faab0246835c7509);
}
module.exports["createEditorContentFragments"] = $69682d2fbc90456d$export$56cbeadb27426f30;
module.exports["EditorContentFragmentsContext"] = $69682d2fbc90456d$export$faab0246835c7509;
module.exports["useEditorContentFragments"] = $69682d2fbc90456d$export$2e53e9edef0785f2;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $99V2N = parcelRequire("99V2N");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $99V2N.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $99V2N.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("b3j2Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, error: error } = t0;
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== error) {
        t1 = ()=>{
            const listener = (event)=>{
                if (event.error === error) event.preventDefault();
            };
            window.addEventListener("error", listener);
            setErrorListenerIsReady(true);
            return ()=>{
                window.removeEventListener("error", listener);
                setErrorListenerIsReady(false);
            };
        };
        t2 = [
            error,
            setErrorListenerIsReady
        ];
        $[0] = error;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    const renderOnError = t3;
    let t4;
    if ($[5] !== error || $[6] !== errorListenerIsReady) {
        t4 = errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
            error: error
        }) : null;
        $[5] = error;
        $[6] = errorListenerIsReady;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== renderOnError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INHERIT,
            renderOnError: renderOnError
        }, t4);
        $[8] = renderOnError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $7rovI = parcelRequire("7rovI");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage || isAccessLinkEdit && isAccessLinkEditing) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("7rovI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $deabcafb397cc045$var$initialState = {
    isAvailable: false,
    isEditMode: false
};
const $deabcafb397cc045$var$setAvailable = (isAvailable)=>({ setState: setState })=>{
        // Leaving the route must also clear edit mode, or a later visit inherits it.
        setState(isAvailable ? {
            isAvailable: isAvailable
        } : {
            isAvailable: false,
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$enterEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: true
        });
    };
const $deabcafb397cc045$var$exitEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$actions = {
    setAvailable: $deabcafb397cc045$var$setAvailable,
    enterEditMode: $deabcafb397cc045$var$enterEditMode,
    exitEditMode: $deabcafb397cc045$var$exitEditMode
};
const $deabcafb397cc045$var$AccessLinkEditModeStore = (0, $8s9DV.createStore)({
    initialState: $deabcafb397cc045$var$initialState,
    actions: $deabcafb397cc045$var$actions,
    name: 'AccessLinkEditModeStore'
});
const $deabcafb397cc045$var$useAccessLinkEditModeStore = (0, $kBr4q.createHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$var$isOnAccessLinkRouteArgs = {
    selector: (routeName)=>{
        return (0, $1NBp8.ACCESS_LINK).name === routeName;
    }
};
/** Actions without a state subscription, so callers that only dispatch do not re-render. */ const $deabcafb397cc045$var$useAccessLinkEditModeStoreActions = (0, $kBr4q.createActionsHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$export$87e25a0d26a92fdb = ()=>{
    const isAvailable = (0, $dPJCf.useRouteName)($deabcafb397cc045$var$isOnAccessLinkRouteArgs);
    const [{ isEditMode: isEditMode }, { enterEditMode: enter, exitEditMode: exit }] = $deabcafb397cc045$var$useAccessLinkEditModeStore();
    return {
        isAvailable: isAvailable,
        isEditMode: isEditMode,
        enterEditMode: enter,
        exitEditMode: exit
    };
};
const $deabcafb397cc045$export$b9623d5da41a49e7 = ({ children: children })=>{
    const { exitEditMode: exitEditMode } = $deabcafb397cc045$var$useAccessLinkEditModeStoreActions();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            exitEditMode();
        };
    }, [
        exitEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["useAccessLinkEditMode"] = $deabcafb397cc045$export$87e25a0d26a92fdb;
module.exports["AccessLinkEditModeProvider"] = $deabcafb397cc045$export$b9623d5da41a49e7;

});

parcelRegister("4S6vT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $87c020c14703301f$var$ContentStateColorSizes = {
    pageHistoryContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '10px',
            width: '10px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.050',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        }),
        scale: 'scale(0.625)',
        viewbox: '0 0 10px 10px'
    },
    rendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginRight: 'space.100',
            marginLeft: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    editorContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.400',
            marginRight: 'space.400'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    contentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    spaceAdminContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px',
            marginRight: 'space.200'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    restoreContentStatesModal: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    subtleContentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px',
            marginRight: 'space.negative.025'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    subtleRendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    contentStateInfoPopup: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginRight: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    }
};
// The SVG defaults to 16x16
// We need to scale to different sizes
const $87c020c14703301f$var$CheckCircleSvg = (color, dataTestId, scale, viewbox)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: viewbox,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'block'
        },
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: scale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.62505 0.990813C8.94443 -0.330271 7.05558 -0.330271 6.37496 0.990813C5.96598 1.78463 5.04334 2.1668 4.19284 1.89468C2.77742 1.4418 1.4418 2.77742 1.89468 4.19284C2.1668 5.04334 1.78463 5.96598 0.990813 6.37496C-0.330271 7.05558 -0.330271 8.94443 0.990813 9.62505C1.78463 10.034 2.1668 10.9567 1.89468 11.8072C1.4418 13.2226 2.77742 14.5582 4.19284 14.1053C5.04334 13.8332 5.96598 14.2154 6.37496 15.0092C7.05558 16.3303 8.94443 16.3303 9.62505 15.0092C10.034 14.2154 10.9567 13.8332 11.8072 14.1053C13.2226 14.5582 14.5582 13.2226 14.1053 11.8072C13.8332 10.9567 14.2154 10.034 15.0092 9.62505C16.3303 8.94443 16.3303 7.05558 15.0092 6.37496C14.2154 5.96598 13.8332 5.04334 14.1053 4.19284C14.5582 2.77742 13.2226 1.4418 11.8072 1.89468C10.9567 2.1668 10.034 1.78463 9.62505 0.990813ZM11.2176 5.5246L11.2951 5.59368C11.6175 5.91602 11.6405 6.42433 11.3642 6.77323L11.2951 6.85076L7.73956 10.4063C7.41722 10.7287 6.90894 10.7517 6.56003 10.4754L6.48251 10.4063L4.70473 8.62854C4.3576 8.28141 4.3576 7.71859 4.70473 7.37146C5.02707 7.04912 5.53535 7.02609 5.88425 7.30238L5.96178 7.37146L7.11117 8.52029L10.0381 5.59368C10.3604 5.27134 10.8687 5.24831 11.2176 5.5246Z",
        fill: color
    })));
const $87c020c14703301f$var$getDisplayedColor = (color, isWarning)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#FF7452' : (0, $Uu0Pb.PRIMARY_COLORS).RED;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? color : (0, $8miSe.hexToToken)(color);
};
const $87c020c14703301f$export$5ac2229016dfa3b6 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { color: color, restrictionLevel: t1, appearance: appearance, isWarning: t2, dataTestId: dataTestId } = t0;
    const restrictionLevel = t1 === undefined ? "NONE" : t1;
    const isWarning = t2 === undefined ? false : t2;
    const { ColorContainerStyles: ColorContainerStyles, viewbox: viewbox, PlainContentStateColorStyles: PlainContentStateColorStyles, scale: scale } = $87c020c14703301f$var$ContentStateColorSizes[appearance];
    let T0;
    let t3;
    let t4;
    if ($[0] !== ColorContainerStyles || $[1] !== PlainContentStateColorStyles || $[2] !== color || $[3] !== dataTestId || $[4] !== isWarning || $[5] !== restrictionLevel || $[6] !== scale || $[7] !== viewbox) {
        const displayedColor = $87c020c14703301f$var$getDisplayedColor(color ?? "#2684FF", isWarning);
        const isRestrictedState = restrictionLevel !== "NONE" && !isWarning;
        T0 = (0, $3izAL.default);
        t3 = ColorContainerStyles;
        t4 = isRestrictedState ? $87c020c14703301f$var$CheckCircleSvg(displayedColor, dataTestId, scale, viewbox) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: dataTestId,
            xcss: PlainContentStateColorStyles,
            style: {
                backgroundColor: displayedColor,
                scale: scale
            }
        });
        $[0] = ColorContainerStyles;
        $[1] = PlainContentStateColorStyles;
        $[2] = color;
        $[3] = dataTestId;
        $[4] = isWarning;
        $[5] = restrictionLevel;
        $[6] = scale;
        $[7] = viewbox;
        $[8] = T0;
        $[9] = t3;
        $[10] = t4;
    } else {
        T0 = $[8];
        t3 = $[9];
        t4 = $[10];
    }
    let t5;
    if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t3
        }, t4);
        $[11] = T0;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
module.exports["ContentStateColor"] = $87c020c14703301f$export$5ac2229016dfa3b6;

});


//# sourceMappingURL=EditorContentState.367e27d1.js.map
